import { EmployeeAddModel } from "./employee.add.model";

export class EmployeeEditModel extends EmployeeAddModel {
    id: string;
    isActive: boolean;
}
